import { Fragment } from 'react';

interface MessageBodyProps {
  text: string;
  className?: string;
}

const URL_REGEX = /(https?:\/\/[^\s<>"']+)/g;
const TRAILING_PUNCT = /[.,;:!?)\]}]+$/;

// Render plain message text and turn any bare http(s) URLs into clickable
// anchors. The wrapper relies on the caller's class to handle whitespace
// (e.g. `white-space: pre-wrap`) so the visual layout matches the previous
// plain-text renderer for messages without URLs.
export function MessageBody({ text, className }: MessageBodyProps) {
  const parts: Array<string | { url: string; trailing: string }> = [];
  let lastIndex = 0;
  for (const match of text.matchAll(URL_REGEX)) {
    const start = match.index ?? 0;
    if (start > lastIndex) {
      parts.push(text.slice(lastIndex, start));
    }
    let url = match[0];
    let trailing = '';
    const trailMatch = url.match(TRAILING_PUNCT);
    if (trailMatch) {
      trailing = trailMatch[0];
      url = url.slice(0, url.length - trailing.length);
    }
    parts.push({ url, trailing });
    lastIndex = start + match[0].length;
  }
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return (
    <div className={className}>
      {parts.map((part, i) =>
        typeof part === 'string' ? (
          <Fragment key={i}>{part}</Fragment>
        ) : (
          <Fragment key={i}>
            <a href={part.url} target="_blank" rel="noopener noreferrer">
              {part.url}
            </a>
            {part.trailing}
          </Fragment>
        )
      )}
    </div>
  );
}
